module.exports = __webpack_public_path__ + "static/media/grid.cf5f5664.svg";